/**
 * Top-right killfeed.
 *
 * The net system owns `state.killfeed`; this widget only reads it. Rows are
 * built once and reused; entries fade out from their own `t` timestamp
 * (seconds, `performance.now()/1000`), so nothing has to be consumed or
 * spliced — an entry that is never removed simply stops being drawn.
 */
import { WEAPON_BY_KEY, TEAM } from '../../net/protocol.js';
import { el, setText, setClass, setOpacity, setStyle, clamp01 } from './dom.js';

const MAX_ROWS = 6;
const LIFE = 6;
const FADE = 1;

const T_COL = '#d9a441';
const CT_COL = '#5b8dd6';
const NEUTRAL = '#cfcfcf';

function teamColor(team) {
  if (team === TEAM.T) return T_COL;
  if (team === TEAM.CT) return CT_COL;
  return NEUTRAL;
}

export class Killfeed {
  constructor(parent) {
    const root = el('div', 'cs-kf', parent);
    this.root = root;
    this.rows = new Array(MAX_ROWS);
    for (let i = 0; i < MAX_ROWS; i++) {
      const node = el('div', 'cs-kf-row', root);
      const row = {
        node,
        killer: el('span', 'cs-kf-k', node, ''),
        hs: el('i', 'cs-kf-hs', node),
        weapon: el('span', 'cs-kf-w', node, ''),
        victim: el('span', 'cs-kf-v', node, ''),
      };
      this.rows[i] = row;
    }
  }

  update(feed, now) {
    const n = feed ? feed.length : 0;
    let row = 0;
    // Newest first: walk the array backwards.
    for (let i = n - 1; i >= 0 && row < MAX_ROWS; i--) {
      const e = feed[i];
      if (!e) continue;
      const age = now - (e.t ?? 0);
      if (age > LIFE) continue;
      const r = this.rows[row++];
      setText(r.killer, e.killer ?? '');
      setText(r.victim, e.victim ?? '');
      setText(r.weapon, weaponName(e.weapon));
      setClass(r.hs, 'on', !!e.headshot);
      setStyle(r.killer, 'color', teamColor(e.killerTeam));
      setStyle(r.victim, 'color', teamColor(e.victimTeam));
      setClass(r.node, 'on', true);
      setOpacity(r.node, age > LIFE - FADE ? clamp01((LIFE - age) / FADE) : 1);
    }
    for (; row < MAX_ROWS; row++) setClass(this.rows[row].node, 'on', false);
  }
}

function weaponName(key) {
  if (!key) return '';
  const w = WEAPON_BY_KEY[key];
  return w ? w.name : String(key);
}
